import { useUserContext } from "@web-app/src/context/auth/user.context";
import AuthStore from "../../../services/AuthStore";

type ProtectedButtonProps = {
  onClick?: () => void;
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
};

export default function ProtectedButton({
  children,
  onClick,
  className,
  disabled,
}: ProtectedButtonProps) {
  const { user } = useUserContext();
  const isLoggedIn = !!user;

  function protectedOnClick(
    e:
      | React.MouseEvent<HTMLDivElement, MouseEvent>
      | React.KeyboardEvent<HTMLDivElement>
  ) {
    if (!isLoggedIn) {
      e.preventDefault();
      e.stopPropagation();
      AuthStore.setModalVisible(true);
      return;
    }
    if (!disabled) {
      onClick?.();
    }
  }

  return (
    <div
      onClick={protectedOnClick}
      role={disabled ? "" : "button"}
      tabIndex={0}
      onKeyDown={protectedOnClick}
      className={className}
    >
      {children}
    </div>
  );
}
